import { TenantEntity } from '../TenantEntity'

export class DischargingTruckingContainerUsage extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'DischargingTruckingContainerUsage'
  }
  get dischargingTruckingUuid() {
    return this._data.dischargingTruckingUuid
  }
  set dischargingTruckingUuid(dischargingTruckingUuid) {
    this._data.dischargingTruckingUuid = dischargingTruckingUuid
  }
  get containerUsageUuid() {
    return this._data.containerUsageUuid
  }
  set containerUsageUuid(containerUsageUuid) {
    this._data.containerUsageUuid = containerUsageUuid
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight || 0
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage || 0
  }
  get truckingFee() {
    return this._data.truckingFee
  }
  set truckingFee(truckingFee) {
    this._data.truckingFee = truckingFee || 0
  }
}
